module.exports = __webpack_public_path__ + "static/media/Gratitude.48562f9a.png";